<template>
  <div
    v-if="isComponentVisible"
    class="text-sm leading-8"
  >
    <PhoneNumber
      v-if="isPhoneVisible"
      :phone-number="contactInformation.phoneNumber"
    />
    <EmailAddress
      v-if="isEmailVisible"
      :email-address="contactInformation.emailAddress"
    />
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'ContactInformation',

  props: {
    showEmail: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {

    const { contactInformation } = useStoreVsfExtended();

    const isEmailVisible = computed(() => props.showEmail && !!contactInformation.value.emailAddress);
    const isPhoneVisible = computed(() => !!contactInformation.value.phoneNumber);
    const isComponentVisible = computed(() => isEmailVisible.value || isPhoneVisible.value);

    return {
      contactInformation,
      isEmailVisible,
      isPhoneVisible,
      isComponentVisible,
    };
  
  },
});

</script>
